import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toast = {
    html: '',
    hidden: true
  }
  toast$ = new BehaviorSubject(this.toast);

  constructor() {}

  setToast(html) {
    this.toast = {html: html, hidden: false}
    this.toast$.next(this.toast);
    setTimeout(()=>{
      this.toast.hidden = true;
      this.toast$.next(this.toast);
    }, 3000)
  }
}
